jQuery(function(){
    let currentTime = new Date().getTime();
    var popup_section = $('.cc-promo-strip');
    popup_section.each(function(){
        var this_popup = $(this),
            this_index = $(this).index(),
            popup_close = popup_section.find('.sf-topbar__close');
        popup_close.click(function(){
            var this_parent = $(this).parents('.cc-promo-strip');
            document.documentElement.style.setProperty('--sf-announcement-height', '0px');
            this_parent.remove();
            this_parent.addClass('hidden');
            localStorage.setItem('popUpHidden-' + this_index, true);
            localStorage.setItem('timeClosed-' + this_index, currentTime);
        });

        if(localStorage.getItem('popUpHidden-' + this_index, true)) {
            this_popup.addClass('hidden');
        }
    
        const closedTime = parseInt(localStorage.getItem('timeClosed-' + this_index));
        const oneDay = 86400000; //24hrs in ms
    
        if(currentTime >= closedTime + oneDay) {
            localStorage.setItem('popUpHidden-' + this_index, false);
            this_popup.removeClass('hidden');
        }
    });

    var var_popup = $('.popup_prod_variant'),
        var_popup_close = var_popup.find('.popup_close'),
        var_img = var_popup.find('.prod_img'),
        var_img_li = var_img.find('li'),
        var_pick = var_popup.find('.variant_picker'),
        var_form = var_popup.find('form'),
        var_input_name = var_form.find('input[name=id]'),
        var_btn = var_form.find('.product-info__add-to-cart button');

    $(document).on('click', '.variant_popup', function(e){
        e.preventDefault();

        var prod_id = $(this).data('prod_id'),
            active_prod = $('#product-' + prod_id);

        var_popup.not(active_prod).removeClass('active_prod');
        active_prod.addClass('active_prod');
        $('body').addClass('disable_scroll');
    });

    var_popup_close.click(function(){
        var this_par = $(this).parents(var_popup);

        this_par.removeClass('active_prod');
        $('body').removeClass('disable_scroll');
    });

    if ( var_pick.length > 0 ) {
        var option_input = var_pick.find('input[type=radio]'),
            option_first_checked = var_pick.find('input[type=radio]:checked'),
            option_first_val = option_first_checked.val(),
            label_value = var_pick.find('.label_value');

        option_input.on('change', function(){
            var this_val = $(this).val(),
                this_label = $(this).data('label');
            active_var(this_val, this_label);
        });
        
        function active_var($data, $label) {
            var active_img = $('#img_' + $data);

            if ( $label ) {
                label_value.text($label);
            }

            var_img_li.not(active_img).removeClass('active_img');
            active_img.addClass('active_img');
            var_input_name.val($data);
            
        }//active_var(option_first_val);
    }

    var_btn.click(function(){
        var this_btn = $(this);

        var success_interval = setInterval(function(){
            if (this_btn.hasClass('is-success')) {
                this_par = this_btn.parents(var_popup).removeClass('active_prod');
                $('body').removeClass('disable_scroll');
                console.log('Success');
                clearInterval(success_interval);
            } else {
                console.log('Loading');
            }
        },100);
    });

});